import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../layout/breadcrumb";
import "./project-detail.css";
import { useLocation } from "react-router-dom";
import DprHeader from "../../layout/dprHeader";
import { DPR_API } from "../../../services/apiCalls/dprApiCalls";
import { toast } from "react-toastify";
import { PROJECT_API } from "../../../services/apiCalls/projectApiCalls";

export default function ProjectDetail() {
  const location = useLocation();
  const pro = location.state || {};

  const [user, setUser] = useState();
  const [billing, setBilling] = useState([]);
  const [qualityM, setQualityM] = useState([]);
  const [safteyM, setSafteyM] = useState([]);
  const [projectDetail, setProjectDetail] = useState({
    project_id: "",
    PO_No: "",
    PO_Date: "",
    Project_Number: "",
    Project_Name: "",
    Brief_description: "",
    Region: "",
    Location: "",
    Product_Category: "",
    Area_of_project: "",
    baseline_start: "",
    baseline_finish: "",
    StartDate: "",
    EndDate: "",
    Project_budget: "",
    Project_Manager: "",
    PPC_manager: "",
    Sales_Manager: "",
    Design_Manager: "",
    supply_chain_Manager: "",
    Execution_partner: "",
    ComponentManufacturer: "",
    Quality_Manager: "",
    Safety_Manager: "",
    Customer_Id: "",
    Billing_Type: "",
    ProjectStatus: "",
    ProjectIdentifier: "",
    ProjectGUID: "",
    ProjectCreatedDate: "",
    ProjectOwnerName: "",
    ProjectAuthorName: "",
    AssignedBy: "",
    DPRRequired: "",
    Project_logo: "",
    Created_dt: "",
  });

  const getProjectSigle = async () => {
    let obj = {
      EmailID: user?.Email,
      ProjectID: projectDetail?.project_id,
    };
    const project = await PROJECT_API?.getProjects(obj);
    if (project.status == 200 && project?.project) {
      let fls = project?.project.filter(
        (fl) => fl?.project_id == pro?.project_id
      );
      setProjectDetail(fls[0]);
      if (fls?.length > 0) {
        setTimeout(() => {
          getSafetyManager(fls[0]);
          getQualityManager(fls[0]);
          getBillingType(fls[0]);
        }, 500);
      }
    }
  };

  const getBillingType = async (data) => {
    const bill = await DPR_API.getBilling();
    if (bill && bill?.BillingTypeList?.length) {
      const user = JSON.parse(localStorage.getItem("state"));
      if (user.user?.Role == "Project Manager") {
        let sftfl = bill?.BillingTypeList.filter(
          (fl) => fl?.BillingType == data?.Billing_Type
        );
        let proDetails = data;
        proDetails["Billing_Type"] = sftfl[0]?.ID;
        setProjectDetail(proDetails);
      }
      setBilling(bill?.BillingTypeList);
    }
  };

  const getQualityManager = async (data) => {
    const bill = await DPR_API.GetUserByRoleID({ RoleID: "5" });
    if (bill && bill?.UserResponseList?.length) {
      const user = JSON.parse(localStorage.getItem("state"));
      if (user.user?.Role == "Project Manager") {
        let sftfl = bill?.UserResponseList.filter(
          (fl) => fl.Name == data?.Quality_Manager
        );
        let proDetails = data;
        proDetails["Quality_Manager"] = sftfl[0]?.ID;
        setProjectDetail(proDetails);
      }

      setQualityM(bill?.UserResponseList);
    }
  };
  const getSafetyManager = async (data) => {
    const bill = await DPR_API.GetUserByRoleID({ RoleID: "6" });
    if (bill && bill?.UserResponseList?.length) {
      const user = JSON.parse(localStorage.getItem("state"));
      if (user.user?.Role == "Project Manager") {
        let sftfl = bill?.UserResponseList.filter(
          (fl) => fl.Name == data?.Safety_Manager
        );
        let proDetails = data;
        proDetails["Safety_Manager"] = sftfl[0]?.ID;
        setProjectDetail(proDetails);
      }
      setSafteyM(bill?.UserResponseList);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("state"));
    setUser(user.user);
    getProjectSigle();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setProjectDetail((prev) => ({ ...prev, [name]: value }));
  };

  const onUpdate = async () => {
    let obj = {
      project_id: projectDetail?.project_id,
      Quality_Manager: projectDetail?.Quality_Manager,
      Safety_Manager: projectDetail?.Safety_Manager,
      Billing_Type: projectDetail?.Billing_Type,
      ProjectGUID: projectDetail?.ProjectGUID,
    };
    // r/eturn
    const update = await DPR_API.UpdateProjectDetails(obj);
    if (update && update?.status === 204) {
      toast.success(update?.Message, { autoClose: 2000 });
      getProjectSigle();
    }
  };

  return (
    <React.Fragment>
      <Breadcrumbs
        title="Project Details"
        menu="My Projects"
        link="Project Details"
      />
      <DprHeader project={pro} />
      <div className="pb-5">
        <div className="row card-custom pb-5">
          {/* <div className='row'>
                    <div className='col-4' style={{ paddingLeft: 0 }}>
                        <label>My Projects</label>
                        <div>
                            <select className='filter-label' style={{ width: "100%", height: 31, border: "1px solid #e6e3e3", borderRadius: 4 }}>
                                <option>Select Project</option>
                            </select>
                        </div>
                    </div>
                </div> */}
          <div className="card card-custom mt-3">
            <div className="card-body">
              <div className="row">
                <div className="col-3">
                  <label className="label-custom">PO No</label>
                  <input
                    value={projectDetail.PO_No}
                    name="PO_No"
                    disabled
                    type="text"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">PO Date</label>
                  <input
                    disabled
                    value={projectDetail.PO_Date}
                    name="PO_Date"
                    type="text"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Project Number</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Project_Number}
                    name="Project_Number"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Project Name</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Project_Name}
                    name="Project_Name"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-3">
                  <label className="label-custom">Brief Description</label>
                  <textarea
                    disabled
                    value={projectDetail?.Brief_description}
                    name="Brief_description"
                    type="textarea"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Region</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Region}
                    name="Region"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Location</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail?.Location}
                    name="Location"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Product Category</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Product_Category}
                    name="Product_Category"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-3">
                  <label className="label-custom">
                    Area of Project/Number of projects
                  </label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Area_of_project}
                    name="Area_of_project"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Baseline Start</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.baseline_start}
                    name="baseline_start"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Baseline Finish</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail?.baseline_finish}
                    name="baseline_finish"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Project Budget</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Project_budget}
                    name="Project_budget"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-3">
                  <label className="label-custom">Project Manager</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Project_Manager}
                    name="Project_Manager"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">PPC Manager</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.PPC_manager}
                    name="PPC_manager"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Sales Manager</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Sales_Manager}
                    name="Sales_Manager"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Design Manager</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail.Design_Manager}
                    name="Design_Manager"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-3">
                  <label className="label-custom">Supply chain Manage</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail?.supply_chain_Manager}
                    name="supply_chain_Manager"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Execution Partner</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail?.Execution_partner}
                    name="Execution_partner"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Component Manufacturer</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail?.ComponentManufacturer}
                    name="ComponentManufacturer"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Quality Manager</label>
                  <select
                    // disabled={user?.Role !== "Project Manager"}
                    value={projectDetail?.Quality_Manager}
                    name="Quality_Manager"
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                      color: "gray",
                      fontSize: 13,
                      paddingLeft: 10,
                    }}
                  >
                    <option>---</option>
                    {qualityM?.map((val) => (
                      <option value={val?.ID}>{val?.Name}</option>
                    ))}
                  </select>
                  {/* <input  type='text' value={projectDetail?.Quality_Manager} name='Quality_Manager' className='form-control shadow-none' /> */}
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-3">
                  <label className="label-custom">Safety Manager</label>
                  <select
                    // disabled={user?.Role !== "Project Manager"}
                    value={projectDetail?.Safety_Manager}
                    name="Safety_Manager"
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                      color: "gray",
                      fontSize: 13,
                      paddingLeft: 10,
                    }}
                  >
                    <option>---</option>
                    {safteyM?.map((val) => (
                      <option value={val?.ID}>{val?.Name}</option>
                    ))}
                  </select>
                  {/* <input type='text' value={projectDetail?.Safety_Manager} name='Safety_Manager' className='form-control shadow-none' /> */}
                </div>
                <div className="col-3">
                  <label className="label-custom">Customer ID</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail?.Customer_Id}
                    name="Customer_Id"
                    className="form-control shadow-none"
                  />
                </div>
                <div className="col-3">
                  <label className="label-custom">Billing Type</label>

                  <select
                    // disabled={user?.Role !== "Project Manager"}
                    value={projectDetail?.Billing_Type}
                    name="Billing_Type"
                    onChange={handleChange}
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                      color: "gray",
                      fontSize: 13,
                      paddingLeft: 10,
                    }}
                  >
                    <option>---</option>
                    {billing?.map((val) => (
                      <option value={val?.ID}>{val?.BillingType}</option>
                    ))}
                  </select>
                  {/* <input  type='text' value={projectDetail?.Billing_Type} name='Billing_Type'  className='form-control shadow-none' /> */}
                </div>
                <div className="col-3">
                  <label className="label-custom">Project Status</label>
                  <input
                    disabled
                    type="text"
                    value={projectDetail?.ProjectStatus}
                    name="ProjectStatus"
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              {/* {user?.Role == "Project Manager" ? */}
              <div className="row mt-4">
                <div className="col-4">
                  <button className="btn btn-primary" onClick={onUpdate}>
                    Update
                  </button>
                </div>
              </div>
              {/* </div> : ""} */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
